var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPractices = function SvgPractices(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1032 139 15.05 18.59",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .practices-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "practice_icon",
    "data-name": "practice icon",
    transform: "translate(1032 139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1349",
    "data-name": "Path 1349"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7835",
    "data-name": "Rectangle 7835",
    className: "practices-1",
    width: 5.31,
    height: 1,
    transform: "translate(4.75 5.14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1350",
    "data-name": "Path 1350"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7836",
    "data-name": "Rectangle 7836",
    className: "practices-1",
    width: 1,
    height: 5.31,
    transform: "translate(6.92 2.98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1514",
    "data-name": "Rectangle 1514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8431",
    "data-name": "Path 8431",
    className: "practices-2",
    d: "M2,0H13.05a2,2,0,0,1,2,2V18.59H0V2A2,2,0,0,1,2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8432",
    "data-name": "Path 8432",
    className: "practices-1",
    d: "M14.05,18.59H1a1,1,0,0,1-1-1V2A2,2,0,0,1,2,0H13.05a2,2,0,0,1,2,2V17.59A1,1,0,0,1,14.05,18.59ZM2,1A1,1,0,0,0,1,2V17.59H14.05V2a1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1515",
    "data-name": "Rectangle 1515"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7837",
    "data-name": "Rectangle 7837",
    className: "practices-2",
    width: 5.41,
    height: 7.97,
    rx: 1,
    transform: "translate(4.76 10.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8433",
    "data-name": "Path 8433",
    className: "practices-1",
    d: "M9.17,18.59H5.76a1,1,0,0,1-1-1v-6a1,1,0,0,1,1-1H9.17a1,1,0,0,1,1,1v6A1,1,0,0,1,9.17,18.59Zm-3.41-7v6H9.17v-6Zm0-.5v.5h0Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPractices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/practices.ec1926ed.svg";
export { ForwardRef as ReactComponent };